import axios from 'axios'

// action types
export const FETCH_GEOJSON = 'fetchGeojson'

// mutation types
export const SET_GEOJSON = 'setGeojson'

const state = {
  jawa_tengah: null,
  ntt: null,
}

const getters = {
  // fix me!
  getJateng(state) {
    return state.jawa_tengah
  },
  getNtt(state) {
    return state.ntt
  },
}

const actions = {
  [FETCH_GEOJSON](context) {
    if (!this.state.jawa_tengah && !this.state.ntt) {
      const baseUrl = process.env.VUE_APP_BASE_URL
      const fetchPosts = async (label) => {
        try {
          const data = await axios.get(`${baseUrl}/media/map/${label}.json`)
          return data
        } catch (error) {
          console.log(error)
        }
      }

      const regions = ['jawa_tengah', 'ntt']
      regions.forEach(async (label) => {
        const post = await fetchPosts(label)
        // console.log(`Asynchronous ${post} is fetched for ${label}`)
        context.commit(SET_GEOJSON, { post, label })
      })
    }
  },
}

const mutations = {
  [SET_GEOJSON](state, payload) {
    state[payload.label] = Object.freeze(payload.post.data)
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
